/* Sui Story — client-side collection filtering, sort & price slider.
   Filters the already-rendered product cards by their data-attributes (tags,
   type, price) — OR within a group, AND across groups. No server round-trips.
   Delegated listeners + re-init on Barba page swaps. */
(function () {
  function $(sel, r) { return (r || document).querySelector(sel); }
  function $all(sel, r) { return Array.prototype.slice.call((r || document).querySelectorAll(sel)); }
  function sec() { return document.querySelector('[data-collection-section]'); }
  function fmtINR(v) { return '₹' + Math.round(v).toLocaleString('en-IN'); }

  /* ---- read current filter state ---- */
  function readState(s) {
    var groups = {};
    $all('[data-fgroup]:checked', s).forEach(function (i) {
      var g = i.getAttribute('data-fgroup');
      (groups[g] = groups[g] || []).push({ val: (i.getAttribute('data-fval') || '').toLowerCase(), match: i.getAttribute('data-fmatch') || 'tag' });
    });
    var price = null, pr = $('[data-client-price]', s);
    if (pr) {
      var lo = $('[data-cp-min]', pr), hi = $('[data-cp-max]', pr);
      if (lo && hi) price = { min: Math.min(+lo.value, +hi.value), max: Math.max(+lo.value, +hi.value), full: (+lo.min), fullMax: (+lo.max) };
    }
    return { groups: groups, price: price };
  }

  /* ---- apply filters to the cards ---- */
  var linesShown = 4;    // show 4 rows; "Load More" adds 4 rows on phones (2 cols), 2 on larger screens
  function gridCols(s) {
    var grid = $('[data-grid]', s); if (!grid) return 1;
    var tpl = getComputedStyle(grid).gridTemplateColumns || '';
    var n = tpl.split(/\s+/).filter(function (x) { return x && x !== 'none'; }).length;
    return n > 0 ? n : 1;
  }
  function apply(reset) {
    var s = sec(); if (!s) return;
    if (reset) linesShown = 4;
    var st = readState(s);
    var matching = [];
    $all('[data-product]', s).forEach(function (c) {
      var tags = (c.getAttribute('data-tags') || '').split(',');
      var type = c.getAttribute('data-type') || '';
      var price = parseFloat(c.getAttribute('data-price')) || 0;
      var ok = true;
      Object.keys(st.groups).forEach(function (g) {
        var vals = st.groups[g];
        if (!vals.length) return;
        var hit = vals.some(function (v) { return v.match === 'type' ? type === v.val : tags.indexOf(v.val) !== -1; });
        if (!hit) ok = false;
      });
      if (ok && st.price && (price < st.price.min || price > st.price.max)) ok = false;
      if (ok) matching.push(c); else c.style.display = 'none';
    });
    var limit = linesShown * gridCols(s);
    matching.forEach(function (c, i) { c.style.display = i < limit ? '' : 'none'; });
    var total = matching.length;
    var cnt = $('[data-result-count]', s); if (cnt) cnt.textContent = '(' + total + ')';
    var applyBtn = $('[data-filter-apply]', s); if (applyBtn) applyBtn.textContent = total === 0 ? 'No matching sets' : ('Show ' + total + (total === 1 ? ' set' : ' sets'));
    var empty = $('[data-empty]', s); if (empty) empty.hidden = total !== 0;
    var allShown = limit >= total;
    var more = $('[data-load-more]', s); if (more) more.style.display = (allShown || total === 0) ? 'none' : '';
    var done = $('[data-load-done]', s);
    if (done) {
      if (total > 0 && allShown) { done.hidden = false; done.textContent = 'Showing all ' + total + ' sets'; }
      else done.hidden = true;
    }
    renderActive(s);
    syncActiveHeaders(s);
  }

  /* ---- active-filter chips above the grid ---- */
  function renderActive(s) {
    var html = '';
    $all('[data-fgroup]:checked', s).forEach(function (i) {
      html += '<button type="button" class="collection__tag" data-remove="' + i.id + '">' + (i.getAttribute('data-flabel') || '') + ' ×</button>';
    });
    var pr = $('[data-client-price]', s), priceActive = false;
    if (pr) { var lo = $('[data-cp-min]', pr), hi = $('[data-cp-max]', pr); priceActive = lo && hi && (+lo.value !== +lo.min || +hi.value !== +hi.max); }
    if (html || priceActive) html += '<button type="button" class="collection__clear" data-clear>Clear all</button>';
    // Render the applied-filter chips into BOTH the above-grid container and the
    // in-drawer mirror, so they're visible while the mobile drawer is open.
    $all('[data-active], [data-active-drawer]', s).forEach(function (wrap) {
      wrap.innerHTML = html;
      wrap.hidden = !html;
    });
  }

  /* mark a filter group brown when it has an active selection */
  function syncActiveHeaders(s) {
    $all('.collection__filters .accordion', s).forEach(function (acc) {
      acc.classList.toggle('is-active', !!$('[data-fgroup]:checked', acc));
    });
  }

  /* ---- sort ---- */
  function sortCards(mode) {
    var s = sec(); if (!s) return;
    var grid = $('[data-grid]', s); if (!grid) return;
    $all('[data-product]', grid).sort(function (a, b) {
      if (mode === 'price-asc') return (+a.getAttribute('data-price')) - (+b.getAttribute('data-price'));
      if (mode === 'price-desc') return (+b.getAttribute('data-price')) - (+a.getAttribute('data-price'));
      if (mode === 'title-asc') return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
      if (mode === 'title-desc') return (b.getAttribute('data-title') || '').localeCompare(a.getAttribute('data-title') || '');
      return (+a.getAttribute('data-pos')) - (+b.getAttribute('data-pos'));
    }).forEach(function (c) { grid.appendChild(c); });
  }

  /* ---- price slider ---- */
  function paintSlider(pr) {
    var lo = $('[data-cp-min]', pr), hi = $('[data-cp-max]', pr), fill = $('[data-price-fill]', pr);
    var outLo = $('[data-price-out-min]', pr), outHi = $('[data-price-out-max]', pr);
    if (!lo || !hi) return;
    var min = +lo.min, max = +lo.max, a = Math.min(+lo.value, +hi.value), b = Math.max(+lo.value, +hi.value);
    if (fill && max > min) { fill.style.left = ((a - min) / (max - min)) * 100 + '%'; fill.style.right = (100 - ((b - min) / (max - min)) * 100) + '%'; }
    if (outLo) outLo.textContent = fmtINR(a);
    if (outHi) outHi.textContent = fmtINR(b);
  }
  function initSliders(s) {
    $all('[data-client-price]', s || document).forEach(function (pr) {
      if (pr.dataset.ready) return; pr.dataset.ready = '1';
      var lo = $('[data-cp-min]', pr), hi = $('[data-cp-max]', pr);
      if (!lo || !hi) return;
      lo.addEventListener('input', function () { if (+lo.value > +hi.value) lo.value = hi.value; paintSlider(pr); });
      hi.addEventListener('input', function () { if (+hi.value < +lo.value) hi.value = lo.value; paintSlider(pr); });
      paintSlider(pr);
    });
  }
  function resetSlider(pr) { var lo = $('[data-cp-min]', pr), hi = $('[data-cp-max]', pr); if (lo) lo.value = lo.min; if (hi) hi.value = hi.max; paintSlider(pr); }

  /* ---- mobile drawer ---- */
  function openDrawer() { var f = $('[data-filters]'), b = $('[data-filter-backdrop]'); if (f) f.classList.add('is-open'); if (b) b.removeAttribute('hidden'); document.documentElement.style.overflow = 'hidden'; }
  function closeDrawer() { var f = $('[data-filters]'), b = $('[data-filter-backdrop]'); if (f) f.classList.remove('is-open'); if (b) b.setAttribute('hidden', ''); document.documentElement.style.overflow = ''; }

  /* ---- events (delegated) ---- */
  document.addEventListener('change', function (e) {
    if (!sec()) return;
    if (e.target.closest('[data-fgroup]')) { apply(true); return; }
    var sort = e.target.closest('[data-client-sort]');
    if (sort) {
      sortCards(sort.value);
      apply(false);
      var pill = sort.closest('.sort-pill'), span = pill && pill.querySelector('.sort-pill__value');
      if (span) span.textContent = sort.options[sort.selectedIndex].text;
      return;
    }
  });
  document.addEventListener('input', function (e) {
    var pr = e.target.closest('[data-client-price]');
    if (pr && (e.target.matches('[data-cp-min]') || e.target.matches('[data-cp-max]'))) paintSlider(pr);
  });
  document.addEventListener('change', function (e) {
    var pr = e.target.closest('[data-client-price]');
    if (pr && (e.target.matches('[data-cp-min]') || e.target.matches('[data-cp-max]'))) apply(true);
  });
  document.addEventListener('click', function (e) {
    if (!sec()) return;
    var rm = e.target.closest('[data-remove]');
    if (rm) { var inp = document.getElementById(rm.getAttribute('data-remove')); if (inp) inp.checked = false; apply(true); return; }
    if (e.target.closest('[data-clear]')) {
      $all('[data-fgroup]:checked').forEach(function (i) { i.checked = false; });
      var pr = $('[data-client-price]'); if (pr) resetSlider(pr);
      apply(true); return;
    }
    if (e.target.closest('[data-load-more]')) { linesShown += (gridCols(sec()) <= 2 ? 4 : 2); apply(false); return; }
    if (e.target.closest('[data-filter-apply]')) { closeDrawer(); return; }
    if (e.target.closest('[data-filter-open]')) { openDrawer(); return; }
    if (e.target.closest('[data-filter-close]') || e.target.closest('[data-filter-backdrop]')) { closeDrawer(); return; }
  });

  var resizeT;
  window.addEventListener('resize', function () { clearTimeout(resizeT); resizeT = setTimeout(function () { if (sec()) apply(false); }, 200); });

  function boot() { var s = sec(); if (!s) return; initSliders(s); apply(true); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('suistory:page:init', boot);
})();
